import { TableRow, Typography } from '@mui/material';
import React from 'react';
import { TableColumnCell } from 'src/components/TableColumnCell';

export const NO_PAY_ALLOCATION_NO_RECORD_LABEL = 'No record data';
export const PROJECT_ALLOCATION_APPROVER_DOT = '#FFC300';

const cellTypographyProps = {
  paddingBottom: '0.25rem',
  paddingTop: '0.5rem',
  variant: 'body2' as const,
  style: { fontSize: '11px' },
  gutterBottom: true,
  noWrap: true
};

export const formatNoPayHrManagerLabel = (hrManagerName?: string | null) => {
  const trimmed = hrManagerName?.trim();
  if (trimmed) {
    return `${trimmed} (HR Manager)`;
  }
  return '(HR Manager)';
};

type NoPayProjectAllocationRowProps = {
  hrManagerName?: string | null;
};

const NoPayProjectAllocationRow: React.FC<NoPayProjectAllocationRowProps> = ({
  hrManagerName
}) => (
  <TableRow hover>
    <TableColumnCell>
      <Typography {...cellTypographyProps}>
        {NO_PAY_ALLOCATION_NO_RECORD_LABEL}
      </Typography>
    </TableColumnCell>
    <TableColumnCell>
      <Typography {...cellTypographyProps}>
        {NO_PAY_ALLOCATION_NO_RECORD_LABEL}
      </Typography>
    </TableColumnCell>
    <TableColumnCell>
      <Typography {...cellTypographyProps} color="text.primary">
        {NO_PAY_ALLOCATION_NO_RECORD_LABEL}
      </Typography>
    </TableColumnCell>
    <TableColumnCell>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div
          style={{
            background: PROJECT_ALLOCATION_APPROVER_DOT,
            borderRadius: '50%',
            width: '7px',
            height: '7px'
          }}
        />
        <Typography {...cellTypographyProps} color="text.primary">
          {formatNoPayHrManagerLabel(hrManagerName)}
        </Typography>
      </div>
    </TableColumnCell>
  </TableRow>
);

export default NoPayProjectAllocationRow;
